module.exports = __webpack_public_path__ + "media/images/camera-btn-dea73563b53f16fa8dac917ca76b669af218ac3aea0d463bacf6d051218c1a31.png";